import { Record } from 'immutable';
import { moment } from 'omni-common-ui';

const SessionPlanRecord = Record({
  attendanceId: undefined,
  id: undefined,
  index: undefined,
  lessonNumber: undefined,
  cancelReason: undefined,
  period: undefined,
  academicHour: undefined,
  teacher: undefined,
  sessionType: undefined,
  isCancelled: undefined,
  sessionId: null,
  unitId: undefined,
  unitIds: undefined,
  unitOrderingSequence: undefined,
  groupId: undefined,  // set by us (keep it)
  sessionMembers: undefined,
});

class SessionPlan extends SessionPlanRecord {
  isFuture() {
    return this.period.start.isAfter(moment());
  }
}

export default SessionPlan;



// WEBPACK FOOTER //
// ./data/SessionPlans/model/model.js